import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { getData } from "Source/globalFunction";

import Select from "Components/common/Select/Select";
import Avatar from "Components/common/Avatar/Avatar";

@connect(store => {
    return {
        workstreams: store.workstreams
    };
})

class Search extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchIsLoading: false,
            searched: []
        }
    }

    render() {
        const { workstreams, projectId, dispatch } = this.props;

        const searchMembers = value => {
            const url = `/api/projects/${projectId}/members`;

            this.setState({ ...this.state, searchIsLoading: true });
            getData(url, {}, response => {
                if (response) {
                    this.setState({
                        ...this.state,
                        searchIsLoading: false,
                        searched: response.data
                            .filter(m => workstreams.selected.members.map(s => s.id).indexOf(m.user.id) === -1)
                            .filter(m => {
                                if (!value) return true;
                                const name = `${m.user['first-name']} ${m.user['last-name']}`.toLowerCase();
                                return name.includes(value.toLowerCase());
                            })
                            .map(m => ({
                                value: m.user.id,
                                label: `${m.user['first-name']} ${m.user['last-name']}`,
                                others: {
                                    id: m.user.id,
                                    fullName: `${m.user['first-name']} ${m.user['last-name']}`,
                                    role: m.user.role,
                                    avatar: m.user.avatar
                                }
                            }))
                    });
                }
            });
        }

        const handleOpenSelect = () => {
            searchMembers();
        }

        const handleSearchMembers = (value) => {
            searchMembers(value);
        }

        const handleSelectMember = (value) => {
            if(this.props.onSelect) {
                this.props.onSelect();
            }

            // @TODO: fullname should 
            dispatch({type: "UPDATE_WORKSTREAMS_SELECTED", selected: {...workstreams.selected, members: [...workstreams.selected.members, {...value.others, isNew: true}]}});
        }

        return (
            <Select 
                showSelectedInInput={false}
                isSearchable={true}
                isClose={this.props.isClose}
                isLoading={this.state.searchIsLoading}
                placeholder={`Add Users to ${workstreams.selected.workstream}`}
                classes={{options: "searchMemberContainer"}}
                options={this.state.searched}
                renderOption={option => (
                    <div class="memberOption">
                        <div class="memberMainDetails">
                            <Avatar name={option.label} disableTooltip={true} image={option.others.avatar !== "default.png" ? `${this.props.avatarBaseUrl}${option.others.avatar}` : null} />
                            <span>{option.label}</span>
                        </div>
                        <div class="memberRole">
                            <span>{option.others.role}</span>
                        </div>
                    </div>
                )} 
                onOpen={handleOpenSelect}
                onSearch={handleSearchMembers}
                onChange={handleSelectMember}
            />
        );
    }
}

export default Search;
